import '/node_modules/@digital-engineering-experiences/wb-webcomponents/dist/style.css';
import "./App.css";
import { useEffect, useState, startTransition, Suspense } from 'react';
import Login from "./components/Login.tsx";
// import Map from "./components/Map.tsx";
import Header from './components/Header.tsx';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import { getRoutesFromFileStructure } from './utils/routeUtils';

function App() {
  const [routes, setRoutes] = useState([]);

  useEffect(() => {
    async function fetchRoutes() {
      const generatedRoutes = await getRoutesFromFileStructure();
      startTransition(() => {
        setRoutes(generatedRoutes);
      });
    }

    fetchRoutes();
  }, []);

  return (
    <Router>
      <div className="App">
        <Header />
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Login />} />

            {routes.map((routeItems, index) => (
                <Route key={index} path={routeItems.path} element={<routeItems.component />} />
            ))}
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;